import React from 'react'
import DashboardLayout from '../../../layoutcontainers/DashboardLayout'
import UnderDevelopmentPage from '../../UnderDevelopmentPage'

const Reports = () => {
  return (
    <DashboardLayout>
      <UnderDevelopmentPage />
    </DashboardLayout>
  )
}

export default Reports
